
import axios from 'axios'

class ClinicPage {
    constructor (theme, elem) {
        this.theme = theme
        this._elem = elem
        this._clinicsUrl = 'https://medichecks.eastsideapps.io/api/clinics'
        this._data = null
    }

    onInit () {
        const handle = this._elem.dataset.clinicPage
        if (handle) {
            this.getData(handle)
        }
    }
    async getData (handle) {
        const response = await axios.get(this._clinicsUrl)
        if (response) {
            for (let clinic of response.data) {
                if (clinic.shopify_page_handle === handle) {
                    this._data = clinic
                    break
                }
            }
            if (this._data) {
                this.useData()
            }
        }
    }
    useData () {
        if (this._data) {
            const badge = this._elem.querySelector('[data-clinic-page-badge]')
            if (badge) {
                if (this._data.holding_stock > 0) {
                    badge.classList.add('active')
                }
            }
            const actions = this._elem.querySelector('[data-clinic-page-action]')
            if (actions) {
                const save = actions.querySelector('[data-clinic-page-save]')
                const saved = actions.querySelector('[data-clinic-page-saved]')
                if (window.localStorage && save && saved) {
                    if (parseInt(window.localStorage['esc-selected-clinic']) === parseInt(this._data.id)) {
                        saved.classList.add('active')
                    } else {
                        save.classList.add('active')
                        save.addEventListener('click', () => {
                            window.localStorage['esc-selected-clinic'] = this._data.id
                            save.classList.remove('active')
                            saved.classList.add('active')
                        })
                    }
                }
            }
        }
    }
}

export default ClinicPage



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ClinicPage.js